import { ReactElement, useEffect, useState } from 'react';

import { ModalBkg, Contact, TextArea, FormWrapper } from './styles';
import { Cpf, Phone } from '../../utils/masks';
import ClearIcon from '@material-ui/icons/Clear';
import ButtonLocal from '../../ui/Button';
import Load from '../../ui/SimpleLoad';

import { ScheduleRootState, UserInfo } from '../../store/redux';
import { useSelector } from 'react-redux';

import { sendNurseMail } from '../../utils/services';

function getValidationErrors(
  name: string, phone: string, email: string, cpf: string, message: string
): { listErros: Record<string, boolean>; errorMessage: string } | null {
  if (!name || !phone || !email || !cpf || !message) {
    return {
      listErros: { name: !name, phone: !phone, email: !email, cpf: !cpf, message: !message },
      errorMessage: 'Preencha os campos em vermelho:'
    };
  }
  if (cpf.length < 12) {
    return {
      listErros: { name: false, phone: false, email: false, cpf: true, message: false },
      errorMessage: 'CPF inválido'
    };
  }
  return null;
}

type props = {
  open: boolean
  setOpen: (value: boolean) => void
};
export default function ContactNurse(props: Readonly<props>): ReactElement {
  // eslint-disable-next-line no-lone-blocks
  if (props.open) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }
  const userInfo: UserInfo = (useSelector<ScheduleRootState, UserInfo>(scheduleReducer => scheduleReducer.user));
  const [erro, setErro] = useState('');
  const [erros, setErros] = useState<Record<string, boolean>>({});
  const [responseMessage, setResponseMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    setName(`${userInfo.firstName} ${userInfo.lastName}`);
    setPhone(userInfo?.phone ?? '');
    setEmail(userInfo?.email ?? '');
    setCpf(Cpf(userInfo?.document ?? ''));
  }, [userInfo]);

  async function handleSend(): Promise<any> {
    const validation = getValidationErrors(name, phone, email, cpf, message);
    if (validation) {
      setErro(validation.errorMessage);
      setErros(validation.listErros);
      return;
    }

    setLoading(true);
    const data = {
      nome: name,
      mail: email,
      telefone: phone.replaceAll(/[^\d]+/g, ''),
      cpf: cpf.replaceAll(/[^\d]+/g, ''),
      mensagem: message
    };
    const sendMailResponse = await sendNurseMail(data);
    if (sendMailResponse.statusCode === 400) {
      setErro(sendMailResponse.response);
    } else {
      setResponseMessage('Sua mensagem foi enviada com sucesso');
      setName('');
      setPhone('');
      setEmail('');
      setCpf('');
      setMessage('');
    }
    setLoading(false);
  }
  return (
    <ModalBkg open={props.open} onClick={ () => props.setOpen(false)}>
      <Contact onClick={e => { e.stopPropagation(); }}>
        <div className="flex">
          <button onClick={ () => props.setOpen(false)}>
            <ClearIcon/>
          </button>
        </div>
        <FormWrapper>
          {/* <ContactWrapper>
            <CircleIcon><IconPhone/></CircleIcon>(11) 2151-7690
          </ContactWrapper> */}
          {loading
            ? (
              <Load left="45%" />
              )
            : (
              <>
                {erro && (
                  <p className="error">{erro}</p>
                )}
                {responseMessage && (
                  <p className="success">{responseMessage}</p>
                )}
                <br />
                <div className="form-group">
                  <input
                    id="contact-name"
                    className={ erros.name && name === '' ? 'form-control required' : 'form-control'}
                    value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome" />
                  <label className="form-label" htmlFor="contact-name">Nome</label>
                </div>
                <div className="form-group">
                  <input
                  id="contact-phone"
                  className={ erros.phone && phone === '' ? 'form-control required' : 'form-control'}
                  value={phone} onChange={(e) => setPhone(Phone(e.target.value))} placeholder="DDD + Telefone" />
                  <label className="form-label" htmlFor="contact-phone">DDD + Telefone</label>
                </div>
                <div className="form-group">
                  <input
                  id="contact-email"
                  className={ erros.email && email === '' ? 'form-control required' : 'form-control'}
                  value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mail" />
                  <label className="form-label" htmlFor="contact-email">E-mail</label>
                </div>
                <div className="form-group">
                  <input
                  id="contact-cpf"
                  className={ erros.cpf && cpf === '' ? 'form-control required' : 'form-control'}
                  value={cpf} onChange={(e) => setCpf(Cpf(e.target.value))} placeholder="CPF" />
                  <label className="form-label" htmlFor="contact-cpf">CPF</label>
                </div>
                <TextArea
                className={ erros.message && message === '' ? 'required' : ''}
                placeholder="Mensagem" value={message} onChange={(e) => setMessage(e.target.value)} />
                <ButtonLocal
                  onClick={ async () => handleSend() }
                  bkColor="white"
                  border="solid 1px #009DFF"
                  color="#009DFF" width={300}
                  height={50} fontWeight="700"
                  fontSize="14px"
                >
                  Enviar
                </ButtonLocal>
              </>
              )}
        </FormWrapper>
      </Contact>
    </ModalBkg>
  );
}
